import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TabService {
  private dataSubject = new BehaviorSubject<any>(this.loadData());
  public data$ = this.dataSubject.asObservable();

  updateTab(data: any) {
    localStorage.setItem('activeTab', JSON.stringify(data));
    this.dataSubject.next(data);
  }

  clearTab() {
    localStorage.removeItem('activeTab'); // Remove from localStorage
    this.dataSubject.next(null); // Clear BehaviorSubject value
  }

  private loadData(): any {
    const storedData = localStorage.getItem('activeTab');
    return storedData ? JSON.parse(storedData) : null;
  }
}
